import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useDispatch, useSelector } from 'react-redux';
import { deleteChatMessage, pinMessage, removePinMessage, updateMessage } from '../../../../store/slices/chatSlice';
import { decodedText } from '../../../../helpers/utils';
import SweetAlert from '../../../../components/SweetAlert/SweetAlert';
import Swal from 'sweetalert2';
import { blockParticipant } from '../../../../store/slices/participantSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { messageIdsMatch } from './pinnedMessageUtils';

const HoverMenu = ({ msg }) => {
    const dispatch = useDispatch();
    const { pinnedMessage } = useSelector((state) => state.chat);
    const message = msg;
    const text = decodedText(message?.attributes?.sanitizedText);
    const [editText, setEditText] = useState(text);

    const pinTextMessage = () => {
        SweetAlert({
            title: "Do you want to pin this message?",
            text: text,
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(pinMessage(message.id)).unwrap();
            },
        });
    };
    


    const unPinTextMessage = () => {
        SweetAlert({
            title: "Do you want to unpin this message?",
            text: text,
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(removePinMessage(message.id)).unwrap();
            },
        });
    };


    const editTextMessage = () => {
        Swal.fire({
            title: "Edit Message",
            input: "text",
            inputValue: editText,
            showCancelButton: true,
            confirmButtonText: "Save",
            preConfirm: (newText) => {
                if (!newText) {
                    Swal.showValidationMessage("Message cannot be empty!");
                    return false;
                }
                return newText;
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(updateMessage({ id: message.id, newText: result.value })).unwrap();
                setEditText(result.value);
            }
        });
    };


    const blockUserHandler = () => {
        const user = message?.attributes?.user;
        SweetAlert({
            title: "Block User",
            text: `Do you want to block user "(${user?.name})" in this channel?`,
            inputField: "reason",
            confirmAction: async (reason) => {
                Swal.showLoading();
                await dispatch(blockParticipant({
                    message: "User blocked successfully.",
                    reason,
                    id: user?.id
                })).unwrap();
            },
        });
    };


    const deleteMessage = () => {
        SweetAlert({
            title: "Do you want to delete this message?",
            text: text,
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(deleteChatMessage({ id: message.id })).unwrap();
            },
        });
    };



    return (
        <div className="hover-Box">
            <div className='d-flex'>
                <EditIcon
                    style={{ width: '22px', cursor: "pointer", fontSize: "18px" }}
                    onClick={editTextMessage}
                />
            </div>

            <div className='d-flex'>
                <BlockIcon
                    style={{ width: '22px', cursor: "pointer", fontSize: "18px", color: "black" }}
                    onClick={blockUserHandler}
                />
            </div>

            <div className='d-flex'>
                {messageIdsMatch(pinnedMessage?.id, message?.id) ? (
                    <PushPinIcon
                        style={{ width: '22px', cursor: "pointer", fontSize: "18px", color: "blue" }}
                        onClick={unPinTextMessage}
                    />
                ) : (
                    <PushPinOutlinedIcon
                        style={{ width: '22px', cursor: "pointer", fontSize: "18px" }}
                        onClick={pinTextMessage}
                    />
                )}
            </div>

            <div className='d-flex'>
                <DeleteForeverIcon style={{ width: '22px', cursor: "pointer", fontSize: "18px" }} onClick={deleteMessage} />
            </div>
        </div>
    );
};

export default HoverMenu;
